let swapTokenV = true

export function swapToken(b){
  swapTokenV = b
}
export function getSwapToken(){
  return swapTokenV
}


// WEBPACK FOOTER //
// ./src/utils/value.js